module.exports = __webpack_public_path__ + "assets/img/1609.jpg?fc742939ee0aac88fc358bde2b655d9c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1609.jpg
// module id = 1115
// module chunks = 0